import { BrowserRouter, Routes, Route } from "react-router";

import Home from "./component/home/Home";
import TermsandCondition from "./component/layout/main/TermsandCondition";
import PrivacyandPolicy from "./component/layout/main/PrivacyandPolicy";

function App() {
  //console.log("Home component loaded successfully!");
  return (
    <BrowserRouter>  
      <Routes>  
        <Route path="/" element={<Home />} />  
          <Route path="/terms-and-conditions" element={<TermsandCondition />} />
          <Route path="/privacy-policy" element={<PrivacyandPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
